import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { forwardRef, useMemo } from "react";
import StripeCardBox from "./StripeCardBox";
import "./stripeCard.scss";

const Stripe = forwardRef(
  ({ onSaveCard, loading, setLoading, saveCard = false, publicKey }, ref) => {
    // only create stripePromise once per unique publicKey
    const stripePromise = useMemo(() => loadStripe(publicKey || ""), [
      publicKey,
    ]);

    if (!stripePromise) return null; // if no key yet, render nothing

    return (
      <Elements stripe={stripePromise}>
        <StripeCardBox
          onSaveCard={onSaveCard}
          loading={loading}
          setLoading={setLoading}
          saveCard={saveCard}
          ref={ref}
        />
      </Elements>
    );
  }
);

export default Stripe;
